import { IndexedDBCache } from "finhelper";

export default class CacheHelper {
    static SERVER_DATA = "server";

    static generateKey(pattern: string, params: Record<string, string>): string {
        let result = pattern;
        Object.keys(params).forEach((key) => {
            result = result.replace(new RegExp(`{${key}}`, "g"), params[key]);
        });
        return result;
    }

    static startAgain(): void {
        IndexedDBCache.clearAll();
    }

    static clearAll(): void {
        localStorage.clear();
        IndexedDBCache.clearAll();
    }
}
